<script>
  import { onMount } from 'svelte';
  import { selectedGroup, currentPage } from '../store.js';
  import http from '../api/http.js';
  import { Card, CardBody, CardFooter, CardHeader, Pagination, PaginationItem, PaginationLink, Table, Button } from 'sveltestrap';
  import TableColumn from '../components/TableColumn.svelte';
  import formatDate from '../Helpers/DateTimeFormatter'
  import Search from '../components/Search.svelte';
  import ManageCredentialModal from "../modals/ManageCredentialModal.svelte";
  import DeleteCredentialModal from "../modals/DeleteCredentialModal.svelte";


  let searchRefresh = false;
  let searchTerm = "";
  let inputLength = 0;

  let credentials = [];

  let manageCredentialModal;
  let deleteCredentialModal;
  const createCredential = 'createCredential'
  const editCredential = 'editCredential'

  let sortType = {
    ascending: 'ascending',
    descending: 'descending',
    resting: 'resting'
  }

  let activeColumn = {
    columnValue: 0,
    sortType: sortType.ascending,
  };

  const displayNumbers = [10, 25, 50, 100, 200];
  let displayNumber = displayNumbers[0];
  let pageNumber = 1;
  let totalPageCount = 0;
  let totalCredentialCount = 0;


  $:activeColumn;

  $: {
    pageNumber;
    displayNumber;

    if($selectedGroup != undefined){
      loadCredentials(activeColumn.columnValue, activeColumn.sortType);
    }
  }

  async function loadCredentials(columnValue, sortTypeArg){

    if({$selectedGroup} != undefined){
      let ascending = sortTypeArg == sortType.ascending ? true : false;
      let url;

      if(columnValue == undefined){
        columnValue = 0;
      }

      if(ascending == undefined){
        ascending = true;
      }

      if(searchTerm.length > 0 && searchTerm != ""){
        url = `/deploy/dashboard/credentials/${$selectedGroup}/${searchTerm.toLocaleLowerCase()}/${displayNumber}/${pageNumber}/${columnValue}/${ascending}`;
      }else{
        url = `/deploy/dashboard/credentials/${$selectedGroup}/${displayNumber}/${pageNumber}/${columnValue}/${ascending}`;
      }

      const res = await http.get(window.apiBaseUrl + url);

      if(res.status == 200){
        let uiCredentialsCollection = await res.json();
        credentials = uiCredentialsCollection.credentials;
        totalPageCount = uiCredentialsCollection.totalPageCount;
        totalCredentialCount = uiCredentialsCollection.noPaginationCredentialCount;
      }else if(res.status == 404){
        credentials = [];
        totalPageCount = 0;
        totalCredentialCount = 0;
      }
    }
  }

  async function searchCredentials(){
    searchRefresh = true;
    let interval = setInterval( async () => {
      if(searchTerm.length != inputLength){
        pageNumber = 1;
        loadCredentials(activeColumn.columnValue, activeColumn.sortType);
      }

      if(!searchRefresh){
        clearInterval(interval);
      }

      inputLength = searchTerm.length;
    }, 2000);
  }

  function toggleSort(columnValue, theSortType){
    if(activeColumn.value != columnValue){
      activeColumn.columnValue = columnValue;
    }

    switch(theSortType){
      case sortType.resting:
        activeColumn.sortType = sortType.ascending;
        break;
      case sortType.ascending:
        activeColumn.sortType = sortType.descending;
        break;
      case sortType.descending:
        activeColumn.sortType = sortType.ascending;
        break;
    }

    if(activeColumn.sortType != sortType.resting){
      loadCredentials(columnValue, activeColumn.sortType);
    }else{
      activeColumn.columnValue = 0;
      activeColumn.sortType = sortType.ascending;
      loadCredentials(0, activeColumn.sortType);
    }
  }

  function setPageNumber(number){
    pageNumber = number;
  }

  onMount(async () => {
    currentPage.set('credentials');
  });

</script>

<Card class="shadow mb-4">
  <CardHeader>
    <div class="d-flex row" style="position: relative;">
      <h4 class="mt-1 ml-1 font-weight-bold text-primary"><i class="fas far-key"></i> Credentials&nbsp;</h4>
      <div class="ml-4">
        <div class="input-group mb-3">
          <Search id="vessels-search-input" bind:searchTerm on:focusout={() => searchRefresh =  false} on:input={() => searchCredentials()} placeholder="Search Credentials..."></Search>
        </div>
      </div>
      <div class="col-sm">
        <Button id="manage=software-button" color="primary" class="btn-plus btn-icon-split float-right ml-2" on:click={() => manageCredentialModal.show(createCredential, undefined)}>
          <span class="icon">
            <i class="fas fa-plus" style="vertical-align:auto !important;"></i>
          </span>
          <span class="text">
            Create Credentials
          </span>
        </Button>
      </div>
    </div>
  </CardHeader>
  <CardBody>
    <Table responsive>
      <thead>
        <tr>
          <TableColumn on:mousedown={() => toggleSort(0, activeColumn.sortType)} active={activeColumn.columnValue == 0} sortType={activeColumn.sortType}>Name</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(1, activeColumn.sortType)} active={activeColumn.columnValue == 1} sortType={activeColumn.sortType}>Username</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(2, activeColumn.sortType)} active={activeColumn.columnValue == 2} sortType={activeColumn.sortType}>Domain</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(3, activeColumn.sortType)} active={activeColumn.columnValue == 3} sortType={activeColumn.sortType}>Date Created</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(4, activeColumn.sortType)} active={activeColumn.columnValue == 4} sortType={activeColumn.sortType}>Last Altered</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(5, activeColumn.sortType)} active={activeColumn.columnValue == 5} sortType={activeColumn.sortType}>Altered By</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(6, activeColumn.sortType)} active={activeColumn.columnValue == 6} sortType={activeColumn.sortType}>Remote Machine</TableColumn>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {#each credentials as credential}
          <tr id="credential-row-{credential.id}">
            <td>{credential.name}</td>
            <td>{credential.username}</td>
            <td>{credential.domain}</td>
            <td>{formatDate(credential.dateCreated)}</td>
            <td>{formatDate(credential.dateUpdated)}</td>
            <td>{credential.alteredBy}</td>
            <td>{credential.remoteMachine}</td>
            <td>
              <Button id="edit-package-version-button-{credential.id}" color="primary" class="btn-plus btn-icon-split btn-sm" alt="Edit" title="Edit" on:click={() => manageCredentialModal.show(editCredential, credential)}>
                <span class="icon text-white-50">
                  <i class="fas fa-pen"></i>
                </span>
              </Button>
              <Button id="delete-package-version-button-{credential.id}" color="primary" class="btn-plus btn-icon-split btn-sm" alt="Delete" title="Delete" on:click={() => deleteCredentialModal.show(credential)}>
                <span class="icon text-white-50">
                  <i class="fas fa-trash-alt"></i>
                </span>
              </Button>
            </td>
          </tr>
        {/each}
      </tbody>
    </Table> 
  </CardBody>
  <CardFooter> 
    <div class="pagination bg-light shadow-none ml-0 d-flex">
      <small class="mt-3 mr-auto">{pageNumber == 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > totalCredentialCount ? totalCredentialCount:pageNumber * displayNumber)} of {totalCredentialCount} credentials</small>
      <div class="mt-2 justify-content-center">
        <Pagination>
          <PaginationItem disabled={pageNumber == 1}>
            <PaginationLink id="pagination-first-page-button" first on:click={() => pageNumber = 1} href="#"/>
          </PaginationItem>
          <PaginationItem  disabled={pageNumber == 1}>
            <PaginationLink id="pagination-previous-page-button" previous on:click={() => setPageNumber(pageNumber - 1)} href="#" />
          </PaginationItem>
          {#if totalPageCount > 5}
            {#each Array(5) as _, count}
              {#if pageNumber > 3 && pageNumber < totalPageCount - 2}
                <PaginationItem active={pageNumber == count + pageNumber} >
                  <PaginationLink id="pagination-page-{pageNumber + count}-button" on:click={() => setPageNumber(pageNumber + count)} href="#">{pageNumber + count}</PaginationLink>
                </PaginationItem>
              {:else if pageNumber <= 3}
                <PaginationItem active={pageNumber == count + 1} >
                  <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                </PaginationItem>
              {:else if pageNumber >= totalPageCount - 2}
                <PaginationItem active={pageNumber == totalPageCount - 4 + count} >
                  <PaginationLink id="pagination-page-{totalPageCount - 4 + count}-button" on:click={() => setPageNumber(totalPageCount - 4 + count)} href="#">{totalPageCount - 4 + count}</PaginationLink>
                </PaginationItem>
              {/if}
            {/each}
          {:else}
            {#each Array(totalPageCount) as _, count}
              <PaginationItem active={pageNumber == count + 1} on:click={() => pageNumber == count + 1}>
                <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
              </PaginationItem>
            {/each}
          {/if}
          <PaginationItem disabled={pageNumber == totalPageCount}>
            <PaginationLink id="pagination-next-page-button" next href="#" on:click={() => setPageNumber(pageNumber + 1)} />
          </PaginationItem>
          <PaginationItem disabled={pageNumber == totalPageCount}>
            <PaginationLink id="pagination-last-page-button" last href="#" on:click={() => setPageNumber(totalPageCount)}/>
          </PaginationItem>
        </Pagination>
      </div>
      <div class="mt-2 ml-auto">
        <select class="form-select" id="displayNumberSelect" bind:value={displayNumber}>
          {#each displayNumbers as displayNumber}
            <option value={displayNumber}>{displayNumber}</option>
          {/each}
        </select>
        <label class="ml-1" id="displayNumberLabel" for="displayNumberSelect">Per page</label>
      </div>
    </div>
  </CardFooter>
</Card>

<ManageCredentialModal bind:this={manageCredentialModal} on:modalClosed={() => loadCredentials(activeColumn.columnValue, activeColumn.sortType)}></ManageCredentialModal>
<DeleteCredentialModal bind:this={deleteCredentialModal} on:modalClosed={() => loadCredentials(activeColumn.columnValue, activeColumn.sortType)}></DeleteCredentialModal>

<style>
  #displayNumberSelect{
    max-height: 30px;
    background-color: white;
    border-radius: 6px;
    border: 1px solid #DEDEDE;
    height:400px;
    color:#3a3a3a;
  }
</style>